import { Injectable } from '@angular/core';
import { Group, GroupsService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { GroupApiActions, GroupResolverActions, GroupListUIActions, GroupListItemUIActions } from './group.actions';
import { safeMap } from '../effects.helpers';
import { GroupApiActions as MemberGroupGroupApiActions } from '../member-group/member-group.actions';

@Injectable()
export class GroupEffects {
  constructor(
    private readonly groupService: GroupsService,
    private readonly actions$: Actions
  ) {}

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupResolverActions.groupsRequested),
      mergeMap(() =>
        safeMap(
          this.groupService.getGroups(),
          (groups: Group[]) => GroupApiActions.groupsLoaded({ groups }),
          (error) => GroupApiActions.groupsLoadedError({ error })
        )
      )
    );
  });

  groupDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupListItemUIActions.groupDeleteRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.removeGroup(group.id),
          () => [GroupApiActions.groupDeleted({ group }), MemberGroupGroupApiActions.groupDeleted({ group })],
          (error) => GroupApiActions.groupDeletedError({ group, error })
        )
      )
    );
  });

  groupAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupListUIActions.groupAddRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.addGroup(group),
          (group: Group) => GroupApiActions.groupAdded({ group }),
          (error) => GroupApiActions.groupAddedError({ group, error })
        )
      )
    );
  });
}
